import styled from 'styled-components'

export const Div = styled.div`
  width: 3.125em;
  height: 1.563em;
  background-color: ${props => props.theme};
  border-radius: 0.938em;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/styles/ColorScheme.js